export default __webpack_public_path__ + "static/media/animation.65565caf.webp";